import React, { useState } from 'react';
import './App.css';
import { CurrentUserContext } from './utils/CurrentUserContext';
import { Route, Routes } from 'react-router-dom';
import { Double } from './pages/Double/Double';
import { PageNotFound } from './components/PageNotFound/PageNotFound';
import { LayoutVertical } from './components/LayoutVertical/LayoutVertical';
import { Classic } from './pages/Classic/Classic';
import { Rooms } from './pages/Rooms/Rooms';
import { Start } from './pages/Classic/Start/Start';
import { Skins } from './pages/Classic/Skins/Skins';
import { Game } from './pages/Classic/Game/Game';
import { Final } from './pages/Classic/Final/Final';
import { Profile } from './pages/Profile/Profile';
import { BlackMarket } from './pages/BlackMarket/BlackMarket';
import socketIO, { io, Socket } from 'socket.io-client';
import { ClientToServerEvents, ServerToClientEvents } from './types/socketTypes';

export const App = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loggedIn, setLoggedIn] = useState(true);
    const [isInventoryOpen, setIsInventoryOpen] = useState(false);

    //const socketUrl = window.location.hostname.replace('www.', '');
    const socket = io('https://server.' + 'csgetto.app/' + ':2087/', { secure: true });

    socket.on('doubleGame', (socket) => {
        const type = socket.type;

        console.log(`⚡: ${type} user just connected!`);
    });

    return (
        <CurrentUserContext.Provider value={currentUser}>
            <Routes>
                <Route path="/" element={<LayoutVertical isInventoryOpen={isInventoryOpen} setIsInventoryOpen={setIsInventoryOpen} />}>
                    <Route index element={<Double />} />
                    <Route path="classic/" element={<Classic />}>
                        <Route index path="start" element={<Start />} />
                        <Route path="skins" element={<Skins setIsInventoryOpen={setIsInventoryOpen} />} />
                        <Route path="game" element={<Game />} />
                        <Route path="final" element={<Final />} />
                    </Route>
                    <Route path="rooms" element={<Rooms setIsInventoryOpen={setIsInventoryOpen} />}></Route>
                    <Route path="profile" element={<Profile />}></Route>
                    <Route path="black-market" element={<BlackMarket />}></Route>
                </Route>
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </CurrentUserContext.Provider>
    );
};
